export default "__VITE_ASSET__7PpK1yD0__"